module.exports = __webpack_public_path__ + "img/avatar_operatore.ac60b088.png";